<template>
	<div>
		<div class="contacts--list__item">
			<label class="check">
				<input type="checkbox" />
				<div class="check-mark"></div>
			</label>
			<p class="info__email capital">{{ referrerFullName }}</p>

			<p class="info__address">
				<span :class="statusStyle" class="pad">
					{{ referral.is_paid === 1 ? 'Paid' : 'Unpaid' }}
				</span>
			</p>
			<p class="info__email capital">{{ referredFullName }}</p>
			<p class="info__email capital">{{ referral.created_at | date }}</p>
			<p>
				<button
					@click="updateApproveRequest"
					class="btn-primary btn-sm"
					:class="updateApproveRequestStyle"
					type="button"
					name="approve"
				>
					Approve
				</button>
				<button
					@click="updateDeclineRequest"
					class="btn-primary btn-sm mt-1"
					:class="updateDeclineRequestStyle"
					type="button"
					name="decline"
				>
					Decline
				</button>
			</p>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import form from '../../mixins/form';

export default {
	name: 'referralItem',
	mixins: [form],
	props: {
		referralData: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			referral: this.referralData,
			itemData: ''
		};
	},
	computed: {
		...mapGetters(['getStatus', 'getReferralDetail']),
		referrerFullName() {
			return `${this.referral.referredBy.firstname} ${this.referral.referredBy.lastname}`;
		},
		referredFullName() {
			return `${this.referral.user.firstname} ${this.referral.user.lastname}`;
		},
		updateApproveRequestStyle() {
			return ['btn__save--outline'];
		},
		updateDeclineRequestStyle() {
			return ['btn__danger'];
		},
		statusStyle() {
			return this.referral.is_paid === 1 ? 'badge badge-pill badge-success' : 'badge badge-pill badge-danger';
		}
	},
	filters: {
		date(val) {
			return moment(val).format('llll');
		}
	},
	methods: {
		...mapActions(['updateReferral']),
		updateApproveRequest() {
			this.referral.is_paid = 1;
			const data = {
				is_paid: 1,
				id: this.referral.id
			};
			this.update(data);
		},
		updateDeclineRequest() {
			this.referral.is_paid = 0;
			const data = {
				is_paid: 0,
				id: this.referral.id
			};
			this.update(data);
		},
		update(data) {
			this.updateReferral(data);
			this.approvalEventFunc();
		},
		approvalEventFunc() {
			this.$emit('approvalRequestButton', 'approvalRequestButtonClicked');
		}
	}
};
</script>

<style scoped>
.badge {
	font-weight: normal;
}
.contacts--list__item {
	display: grid;
	grid-template-columns: 40px 1fr 0.5fr 1fr 1fr 0.8fr !important;
}
.info__primary {
	width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	margin-right: 10px;
}
.info__email {
	text-transform: lowercase;
}
.contacts__info {
	overflow: hidden;
}
.capital {
	text-transform: capitalize;
}
</style>
